import { get_token} from "@/router";

export default {
  name: 'DiscussionTopic',
  props: {
      discussion: {
            type: Map,
        },
      active_profile: {
            type: Object,
            default: null,
        },
  },
  data() {
    return ({
      comments: [],
      comment_text: '',
      show_reply_input: false,
      reply_text: '',
      reply_comment_id:null,
      is_posting_comment: false,
      posting_reply_comment_id: null,
      expanded_comments: {},
      expanded_replies: {},
    });
  },
  mounted() {
    this.fetch_comments();
  },
  methods: {
    getToken() {
    return get_token();
    },
    get_active_base_profile_id() {
      return String(this.active_profile?.id || '');
    },
    get_comment_base_profile_id(comment) {
      return String(
        comment?.created_by?.id ||
        comment?.created_by?.base_profile?.id ||
        comment?.base_profile?.id ||
        ''
      );
    },
    sort_comments_for_active_profile(comments) {
      const active_base_profile_id = this.get_active_base_profile_id();
      if (!active_base_profile_id) return comments || [];

      const own_comments = [];
      const other_comments = [];

      (comments || []).forEach((comment) => {
        if (this.get_comment_base_profile_id(comment) === active_base_profile_id) {
          own_comments.push(comment);
          return;
        }
        other_comments.push(comment);
      });

      return [...own_comments, ...other_comments];
    },
    should_truncate_text(text) {
      const normalized_text = String(text || '').trim();
      return normalized_text.length > 90;
    },
    get_truncated_text(text, limit = 90) {
      const normalized_text = String(text || '').trim();
      if (normalized_text.length <= limit) return normalized_text;
      return `${normalized_text.slice(0, limit).trimEnd()}...`;
    },
    is_comment_expanded(comment_id) {
      return Boolean(
        Reflect.get(this.expanded_comments || {},String(comment_id)));
    },

    is_reply_expanded(reply_id) {
      return Boolean(Reflect.get( this.expanded_replies || {},String(reply_id)));
    },
    toggle_comment_expanded(comment_id) {
          const expanded_comments = {
            ...(this.expanded_comments || {}),
          };

          Reflect.set(expanded_comments,String(comment_id),!this.is_comment_expanded(comment_id)
          );

          this.expanded_comments = expanded_comments;
        },

        toggle_reply_expanded(reply_id) {
          const expanded_replies = {...(this.expanded_replies || {}),
          };

          Reflect.set(expanded_replies, String(reply_id), !this.is_reply_expanded(reply_id)
          );

          this.expanded_replies = expanded_replies;
        },
      get_personal_profile_picture(profileFiles) {
      if (!Array.isArray(profileFiles)) {
        return require('@/assets/images/user.png');
      }

      const profilePic = profileFiles.find(
        file => file.profile_file_type === 'profile_picture'
      );

      return profilePic?.file?.url || require('@/assets/images/user.png');
    },
    fetch_comments() {
      // Replace with your actual API endpoint and logic
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_comments_for_topic/`,
        method: 'POST',
        data: JSON.stringify({
          topic_id: this.discussion.id,
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.comments = this.sort_comments_for_active_profile(response.data);
        },
        error: (err) => {
          console.error('Failed to fetch comments', err);
        }
      });
    },
    post_comment() {
      if (this.is_posting_comment || !this.comment_text?.trim()) return;

      const base_url = `${window.location.origin}${this.$route.path}`;
      this.is_posting_comment = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/post_comment/`,
        method: 'POST',
        data: JSON.stringify({
          topic_id: this.discussion.id,
          comment_text: this.comment_text.trim(),
          base_url: base_url
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.comments.unshift(response.data);
          this.comment_text = '';
        },
        error: (err) => {
          console.error('Failed to fetch comments', err);
        },
        complete: () => {
          this.is_posting_comment = false;
        }
      });
    },
    reply_to_comment(comment_id) {
          if (this.posting_reply_comment_id === comment_id || !this.reply_text?.trim()) return;

          this.posting_reply_comment_id = comment_id;
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reply_to_comment/`,
            method: 'POST',
            data: JSON.stringify({
              topic_id: this.discussion.id,
              comment_id:comment_id,
              reply_text: this.reply_text.trim(),
            }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: () => {
               this.reply_text = '';
               this.show_reply_input = false;
               this.fetch_comments();
            },
            error: (err) => {
              console.error('Failed to fetch comments', err);
            },
            complete: () => {
              this.posting_reply_comment_id = null;
            }
          });
        },
    hide_modal(){
      this.$emit('hide_comment')
    },
    time_ago(dateStr) {
    const date = new Date(dateStr);
    const now = new Date();
    const diff_mss = now - date;
    const diff_sec = Math.floor(diff_mss / 1000);
    const diff_min = Math.floor(diff_sec / 60);
    const diff_hour = Math.floor(diff_min / 60);
    const diff_day = Math.floor(diff_hour / 24);

    if (diff_min < 1) return 'just now';
    if (diff_min < 60) return `${diff_min} minute${diff_min === 1 ? '' : 's'} ago`;
    if (diff_hour < 24) return `${diff_hour} hour${diff_hour === 1 ? '' : 's'} ago`;
    if (diff_day < 7) return `${diff_day} day${diff_day === 1 ? '' : 's'} ago`;

    // Fallback to formatted date: 13 February 2025
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }
  }
};
